export default {
    name: 'LicenseDetails',
    data: function() {
        return {

        }
    },
    mounted() {

    },
    props: {
        license_doc: '',
    },
    methods: {

    }
}
